<template>
    <a
        :href="estimate._links.show"
        class="block p-4 bg-gray-50 hover:bg-gray-100 text-gray-700 hover:text-gray-700"
    >
        <div class="flex sm:items-start justify-between flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
            <h2 class="font-semibold truncate">
                <span class="text-gray-500 tabular-nums font-open-sans" v-text="`#${estimate.id}`"></span>
                <span class="ml-2" v-text="estimate.title"></span>
            </h2>
            <ui-dropdown-date :moment="parseMoment(estimate.created_at)" menu-class="p-3 w-52" #default="{ open, close, dateAgo }">
                <div class="inline-flex items-center text-sm text-gray-500" @mouseenter="open" @mouseleave="close">
                  <div class="text-right">
                    <div>Created {{ dateAgo }} by {{ estimate.created_by }}</div>
                    <div class="text-xs text-gray-400">{{ estimate.created_at }}</div>
                  </div>
                </div>
            </ui-dropdown-date>
        </div>
        <div class="mt-2 text-gray-500">
            <span v-if="estimate.status !== 'draft'">
                <estimates-old-status :estimate="estimate"></estimates-old-status> •
            </span>
            <span v-if="estimate.revision">Revision {{ estimate.revision || 0 }} • </span>
            <span>{{ estimate.cf_amount | toCurrency }}</span>
        </div>
    </a>
</template>

<script>
import { parseMoment } from '@utils'

export default {
    props: {
        estimate: Object,
    },
    methods: {
        parseMoment,
    },
}
</script>
